import { RouteObject } from "react-router-dom";
import {
  TRANSACTION,
  TRANSACTION_DETAILS,
  TRANSACTION_TAB,
} from "constants/urls";

export default [
  {
    index: true,
    path: TRANSACTION,
    lazy: () => import("modules/transaction/pages/Transaction"),
  },
  {
    index: true,
    path: TRANSACTION_TAB,
    lazy: () => import("modules/transaction/pages/Transaction"),
  },
  {
    path: TRANSACTION_DETAILS,
    lazy: () => import("modules/transaction/pages/TransactionDetails"),
  },
] as RouteObject[];
